require('../assets/scss/main.scss');
import Helpers from './helpers';

require('bootstrap-sass/assets/javascripts/bootstrap/transition');
require('bootstrap-sass/assets/javascripts/bootstrap/collapse');
require('bootstrap-sass/assets/javascripts/bootstrap/dropdown');
require('jquery-match-height');

let lastTopOffset = 0;
const offsetMargin = 30;
function handlerScrollMain() {
  const topOffset = jQuery(this).scrollTop();
  if (topOffset > lastTopOffset && topOffset > offsetMargin) {
    jQuery('.navbar').addClass('fadeOutUp');
    jQuery('.navbar').removeClass('fadeInDown');
  } else if (topOffset < lastTopOffset && topOffset <= offsetMargin) {
    jQuery('.navbar').addClass('fadeInDown');
    jQuery('.navbar').removeClass('fadeOutUp');
  }
  lastTopOffset = topOffset;
}

function handlerScrollAnimations(e) {
  const banner = jQuery('#banner');

  if (banner.length < 1) {
    jQuery(this).unbind(e);
  } else if (Helpers.isInViewport(banner)) {
    banner.find('.animated').removeClass('hide');
    banner.find('.animated').addClass('fadeInDown');
    jQuery(this).unbind(e);
  }
}

jQuery(window).on('scroll.main', handlerScrollMain);
jQuery(window).on('scroll.animations', handlerScrollAnimations);

jQuery(function($) {
  $('#jumbo-text').matchHeight({
    target: $('#jumbo-image')
  });
  $('.info__item').matchHeight();
  $('.coworker__name').matchHeight();
  setTimeout(function() {
    $.fn.matchHeight._update();
  }, 500);
});


// WEBPACK FOOTER //
// ./js/main.js